<div class="rs-icon-button" [class.rs-icon-button_selected]="selected">
  <div class="rs-icon-button__icon">
    <mat-icon>{{icon}}</mat-icon>
  </div>
  <button mat-raised-button [disabled]="disabled">
    <ng-content></ng-content>
  </button>
</div>
